/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

import {
    SELECT_IMAGE_TAB, CLEAR_IMAGE_TAB, ADD_TEMPORARY_IMAGE, IMAGE_ERROR, SET_DATA_RECEIVED
} from 'state/actions/embedsState/embedManagementState/image_status';
//CHANGES MADE TO REDUCER
// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //
const getDefaultState = () => ({
    provider: null,
    images: [],
    page_count: 0,
    isDataReceived: false,
    error: false,
});


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const imageStatus = (state = getDefaultState(), action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case SELECT_IMAGE_TAB:
            newState.provider = action.provider;
            newState.images = action.images;
            newState.page_count = action.page_count;
            newState.isDataReceived = true;
            newState.error = false;
            return newState;
        case SET_DATA_RECEIVED:
            newState.isDataReceived = action.data;
            return newState;
        case CLEAR_IMAGE_TAB:
            newState=getDefaultState();
            return newState;
        case IMAGE_ERROR:
            newState.error = true;
            return newState;
        case ADD_TEMPORARY_IMAGE:
            newState.images = [action.imageFile, ...state.images];
            return newState;
        default:
            return state;
    }
}

export default imageStatus;
